import { useMediaQuery } from 'react-responsive'

function useResponsive() {
  const isTabletOrMobile = useMediaQuery({ maxWidth: 991 })
  const isTablet = useMediaQuery({ minWidth: 768, maxWidth: 991 })
  const isMobile = useMediaQuery({ maxWidth: 767 })

  return { isTabletOrMobile, isMobile, isTablet }
}

export default useResponsive